import { AlertCircle, X } from 'lucide-react';
import { useAccountManager } from '@/hooks/use-account-manager';
import { useAccountManagerMode } from '@/contexts/AccountManagerContext';
import { Button } from '@/components/ui/button';

/**
 * Banner that shows when an account manager is in "View as User" mode
 */
export function AccountManagerModeBanner() {
  const { isAccountManager } = useAccountManager();
  const { viewAsUser, setViewAsUser } = useAccountManagerMode();

  // Only show if user is account manager AND in view as user mode
  if (!isAccountManager || !viewAsUser) {
    return null;
  }

  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-3">
      <div className="mx-auto flex max-w-screen-2xl flex-col items-start gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3 sm:items-center">
          <AlertCircle className="mt-0.5 h-5 w-5 flex-shrink-0 text-amber-600 sm:mt-0" />
          <div className="min-w-0">
            <p className="text-sm font-semibold text-amber-900">
              Viewing as Regular User
            </p>
            <p className="text-xs text-amber-700">
              All restrictions and payment validations are active. Your account manager privileges are temporarily disabled.
            </p>
          </div>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setViewAsUser(false)}
          className="w-full shrink-0 text-amber-700 hover:bg-amber-100 hover:text-amber-900 sm:w-auto"
        >
          <X className="mr-1 h-4 w-4" />
          Exit View Mode
        </Button>
      </div>
    </div>
  );
}

